import styled from 'styled-components';
import { ELockInfo } from '@/components/tour/game/NewLocks/LockInfoPopup/types';

export const CollectBlock = styled.div`
  margin-right: 5px;
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media screen and (max-width: 480px) {
    width: 100%;
    align-items: start;
    margin-left: 5px;
  }
`;
export const SequenceBlock = styled.div`
  margin-left: 5px;
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;
export const TempBlock = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  z-index: 99;
  @media screen and (max-width: 480px) {
    margin-left: 5px;
    margin-bottom: 5px;
    position: initial;
    right: initial;
    top: initial;
  }
`;

export const MainWrap = styled.div<{ rtl: boolean }>`
  z-index: 98;
  width: calc(100% - 87px);
  margin-top: 65px;
  position: fixed;
  ${({ rtl }) => (rtl ? 'direction: rtl;' : '')}

  .lip-simpleFlex {
    display: flex;
    justify-content: center;
    @media screen and (max-width: 480px) {
      flex-direction: column;
    }
  }
  @media screen and (max-width: 480px) {
    margin-top: 85px;
  }
`;
export const PopupItem = styled.div<{ value: ELockInfo }>`
  color: black;
  width: 400px;
  //height: 44px;
  max-width: 100%;
  position: relative;
  //margin: auto;
  margin-top: 3px;
  letter-spacing: 0.17px;
  padding: 10px;
  padding-right: 32px;
  font-weight: 400;
  font-size: 14px;
  line-height: 143%;
  box-shadow:
    0px 5px 5px -3px rgb(0 0 0 / 20%),
    0px 8px 10px 1px rgb(0 0 0 / 14%),
    0px 3px 14px 2px rgb(0 0 0 / 12%);
  border-radius: 4px;
  height: auto;
  background: #fff1ef;
  border: 1px solid #f34848;

  @media screen and (max-width: 400px) {
    left: 0;
  }

  .rndd {
    border: 1px solid;
    border-radius: 50%;
    padding: 3px;
    width: 20px !important;
    height: 20px !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 12px;
    color: #f34848;
    border-color: #f34848;
  }

  .lip-clss {
    position: absolute;
    right: 15px;
    font-size: 22px;
    font-weight: normal;
    cursor: pointer;
  }

  span {
    float: right;
    margin: 0 5px;
    //margin: 0 50px;
  }

  .qstn {
    font-weight: bold;
    padding-right: 3px;
    cursor: pointer;
    animation: hintCol;
    animation-delay: 0s;
    animation-direction: alternate;
    animation-duration: 4s;
    animation-fill-mode: none;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    //animation-timing-function: ease;

    @keyframes hintCol {
      from {
        padding: 3px;
        margin-top: 0px;
        margin-bottom: 0px;
        //font-size: 14px;
      }
      to {
        padding: 10px;
        margin-top: -4px;
        margin-bottom: -4px;
        //font-size: 16px;
      }
    }
  }

  ${({ value }) =>
    value === ELockInfo.ok
      ? 'background: #E3FFD6; border: 1px solid #27AE60; .rndd {color: #27AE60; border-color: #27AE60;}'
      : ''}
  ${({ value }) =>
    value === ELockInfo.info_sequence || value === ELockInfo.info_collect
      ? 'background: rgba(255, 255, 255, 0.5); backdrop-filter: blur(15px);border:none;border-radius: 32px; width: auto; .rndd {color: #000; border-color: #000;}'
      : ''}
`;
